import { CommandBlock } from "@/components/CommandBlock";
import { SetupStep } from "@/components/SetupStep";
import { useCopyToClipboard } from "@/lib/useCopyToClipboard";

function roleAssignmentCommand(assignee: string) {
  return [
    "az role assignment create \\",
    '  --role "Azure Kubernetes Service RBAC Reader" \\',
    `  --assignee ${assignee} \\`,
    "  --scope $(az aks show -g <resource-group> \\",
    "    -n <cluster-name> --query id -o tsv)",
  ].join("\n");
}

export function AksAccessSteps({
  credentialType,
  clientId,
}: {
  credentialType: string;
  clientId: string;
}) {
  const { copiedField, copyToClipboard } = useCopyToClipboard();

  if (
    credentialType !== "AzureManagedIdentity" &&
    credentialType !== "AzureServicePrincipal"
  ) {
    return null;
  }

  const ownIdentity = credentialType === "AzureManagedIdentity";

  return (
    <ol className="mt-2">
      {ownIdentity && (
        <SetupStep
          label="1"
          state="current"
          title="Give each gateway or connector a managed identity"
        >
          <p className="mt-1 text-sm text-foreground/70">
            Assign a managed identity where each gateway or connector runs. Use
            a managed identity on Azure VMs or Container Apps, or workload
            identity on AKS. The identity doesn't need any Azure roles of its
            own.
          </p>
        </SetupStep>
      )}
      <SetupStep
        label={ownIdentity ? "2" : "1"}
        state="current"
        title={
          ownIdentity
            ? "Give the identity access to the cluster"
            : "Give the service principal access to the cluster"
        }
        last
      >
        <p className="mt-1 mb-2 text-sm text-foreground/70">
          Assign it a role on the cluster and ensure Microsoft Entra ID
          authentication and Azure RBAC are enabled. Replace{" "}
          {ownIdentity && (
            <>
              <code className="text-foreground">{"<principal-id>"}</code> with
              the identity's principal ID, and{" "}
            </>
          )}
          <code className="text-foreground">{"<resource-group>"}</code> and{" "}
          <code className="text-foreground">{"<cluster-name>"}</code> with the
          cluster's resource group and name.
        </p>
        <CommandBlock
          command={roleAssignmentCommand(
            ownIdentity ? "<principal-id>" : clientId.trim() || "<client-id>",
          )}
          field="aksRoleAssignment"
          copiedField={copiedField}
          onCopy={copyToClipboard}
        />
      </SetupStep>
    </ol>
  );
}
